/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import request from '@/api/request';

var $qs = require('querystring').stringify; // 获取客户列表


export function getCustomerList(data) {
  return request.get('/v2/customer/epCustomerList', {
    params: data
  });
} // 获取所有联系人列表

export function getLinkPersonList(data) {
  return request.get('/v2/customer/epLinkPersonList', {
    params: data
  });
} // 获取联系人列表

export function getLinkPerson(customId) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request.get("/customer/linkperson/list?customId=".concat(customId), {
    params: data
  });
}
export function getLinkPersonCount(customId) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request.get("/customer/linkperson/count?customId=".concat(customId), {
    params: data
  });
} // 保存/编辑联系人

export function saveLinkPerson(data) {
  return request.post('/customer/linkperson/save', $qs(data));
} // 设置默认联系人

export function setDefaultLinkperson(data) {
  return request.post('/customer/linkperson/setDefault', data);
}
export function deleteLinkperson(data) {
  return request.delete('/customer/linkperson/delete', {
    params: data
  });
} // 获取服务地址列表

export function getAddressList(customId, data) {
  return request.get("/customer/address/list?customId=".concat(customId), {
    params: data
  });
}
export function getAddressCount(customId, data) {
  return request.get("/customer/address/count?customId=".concat(customId), {
    params: data
  });
} // 保存/编辑服务地址

export function saveAddress(data) {
  return request.post('/customer/address/save', JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });
}
export function deleteCusAddress(data) {
  return request.delete('/customer/address/delete', {
    params: data
  });
} // 设置默认服务地址

export function setDefaultAddress(data) {
  return request.post('/customer/address/setDefault', data);
} // 获取客户产品列表

export function getCusProductList(customId, data) {
  return request.get("/customer/product/list?customId=".concat(customId), {
    params: data
  });
}
export function getCusProductCount(customId, data) {
  return request.get("/customer/product/count?customId=".concat(customId), {
    params: data
  });
}
export function saveProduct(data) {
  return request.post('/customer/product/save', JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });
}
export function deleteCusProduct(data) {
  return request.delete('/customer/product/delete', {
    params: data
  });
} // 获取服务人员列表

export function getWorkerList(data) {
  // '/worker/list', { // 该接口废弃 修改为新接口
  return request.get('/user/roleUserList', {
    params: data
  });
}
export function getWorkerCount(data) {
  return request.get('/user/roleUserCount', {
    params: data
  });
}
export function getDepartmentPc(data) {
  return request.get('v2/user/getDepartment', {
    params: data
  });
}
export function getUserList(data) {
  return request.get('v2/user/list', {
    params: data
  });
}
export function getUserCount(data) {
  return request.get('v2/user/count', {
    params: data
  });
}
export function getUserListAndCount(data) {
  return Promise.all([getUserList(data), getUserCount(data)]);
}
export function getWorkerListAndCount(data) {
  return Promise.all([getWorkerList(data), getWorkerCount(data)]);
}
export function postBatchRole(data) {
  return request.post('/user/batchDelRoles', data);
}
export function postBatcAddRole(data) {
  return request.post('/user/batchAddRoles', data);
} // 获取全部人员列表

export function getAllUserList(data) {
  return request.get('/v2/user/list', {
    params: data
  });
} // 获取模板列表

export function getTempList(data) {
  return request.get('/temp/list', {
    params: data
  });
} // 获取备件类型列表

export function getSpareTypeList(data) {
  return request.get('/v2/spare/spareTypeList', {
    params: data
  });
} // 获取备件类型列表 带仓库ID

export function getSpareList(data) {
  return request.get('/v2/spare/sparePart/list', {
    params: data
  });
}
export function getSpareCount(data) {
  return request.get('/v2/spare/sparePart/count', {
    params: data
  });
}
export function getSpareListAndCount(data) {
  return Promise.all([getSpareList(data), getSpareCount(data)]);
} // 获取备件列表

export function getSpareParentList(data) {
  return request.get('/sparePart/type/father', {
    params: data
  });
} // 获取个人备件列表

export function getSparepartList(data) {
  return request.get('/settlement/getSparepartList', {
    params: data
  });
} // 客户产品档案

export function getProductList(data) {
  return request.get('/customer/product/prodList', {
    params: data
  });
} // 产品类别父级

export function getProductParentList(data) {
  return request.get('/product/type/father', {
    params: data
  });
} // 产品类别

export function getProductTypeList(data) {
  return request.get('/v2/product/typeList', {
    params: data
  });
}
export function getProductFiledDetail(data) {
  return request.get('v2/product/filedDetail/ignoreState', {
    params: data
  });
} // 产品库

export function getStockProductList(data) {
  return request.get('/v2/product/productList', {
    params: data
  });
}
export function getStockProductCount(data) {
  return request.get('/v2/product/productListCount', {
    params: data
  });
} // 服务项目类别父级

export function getServiceParentList(data) {
  return request.get('/v2/order/type/father', {
    params: data
  });
} // 服务项目类别

export function getServiceTypeList(data) {
  return request.get('/v2/serverItem/serviceTypeList', {
    params: data
  });
} // 服务项目列表

export function getServiceList(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var map = {
    1: '/v2/order/serviceTypeList',
    2: '/v2/event/serviceTypeList'
  };
  return request.get(map[type], {
    params: data
  });
}
export function getAreaList(data) {
  return request.get('/area/list', {
    params: data
  });
}
export function getAreaInfo(data) {
  return request.get('/area/street/list', {
    params: data
  });
}
export function getReceiveList(data) {
  return request.get('/receive/list/orderTmpl', {
    params: data
  });
}
export function getAllReceiveList(data) {
  return request.get('/receive/list', {
    params: data
  });
}